export const StateChanges = {
  // ** front end *
  BUILD_STATE: 'BUILD_STATE',
  CONFIRM_FIRST_TIME_INITIALIZED: 'CONFIRM_FIRST_TIME_INITIALIZED',
  LOAD_DOCUMENT_FILE: 'LOAD_DOCUMENT_FILE',
  EDIT_DOCUMENT_TEXT: 'EDIT_DOCUMENT_TEXT',
  SET_TEXT_FOR_NAKDAN_API_CALL: 'SET_TEXT_FOR_NAKDAN_API_CALL',
  SET_JSON_DATA_FOR_NAKDAN_API_CALL: 'SET_JSON_DATA_FOR_NAKDAN_API_CALL',
  STORE_ALL_PRE_SUBMISSION_OPTIONS: 'STORE_ALL_PRE_SUBMISSION_OPTIONS',
  STORE_ALL_WORKING_NIKUD: 'STORE_ALL_WORKING_NIKUD',
  REWRITE_WORD_IN_WORKING_ARRAY: 'REWRITE_WORD_IN_WORKING_ARRAY',
  REWRITE_WORD_TO_RUN_AND_POS_MAP: 'REWRITE_WORD_TO_RUN_AND_POS_MAP',
  SPLICE_WORDS_IN_WORKING_ARRAY: 'SPLICE_WORDS_IN_WORKING_ARRAY',
  SET_CURRENT_WORD_INDEX: 'SET_CURRENT_WORD_INDEX',
  SET_CURRENT_LETTER_INDEX: 'SET_CURRENT_LETTER_INDEX',
  SET_WORD_AND_LETTER: 'SET_WORD_AND_LETTER',
  SET_SHOW_AIMS: 'SET_SHOW_AIMS',
  SET_NIKUD_KEYBOARD: 'SET_NIKUD_KEYBOARD',
  SET_SHOW_NIKUD_BUTTONS: 'SET_SHOW_NIKUD_BUTTONS',
  SET_DISABLE_GO_HOME_PROMPT: 'SET_DISABLE_GO_HOME_PROMPT',
  SET_DISABLE_BACK_TO_TEXT_PREP_PROMPT: 'SET_DISABLE_BACK_TO_TEXT_PREP_PROMPT',
  SET_DISABLE_SWITCH_GENRE_PROMPT: 'SET_DISABLE_SWITCH_GENRE_PROMPT',
  SET_ALL_POST_SUBMISSION_OPTIONS: 'SET_ALL_POST_SUBMISSION_OPTIONS',
  VALIDATION_FAILURE_POPUP_SHOWN: 'VALIDATION_FAILURE_POPUP_SHOWN',
  UPDATE_USER_DICTIONARY: 'UPDATE_USER_DICTIONARY',
  SET_DISABLE_UPLOAD_DICTIONARY_PROMPT: 'SET_DISABLE_UPLOAD_DICTIONARY_PROMPT',

  // ** concerning APIs *
  NAKDAN_RUNNING: 'NAKDAN_RUNNING',
  NAKDAN_TIMED_OUT: 'NAKDAN_TIMED_OUT',
  NAKDAN_FAILED: 'NAKDAN_FAILED',
  SET_NAKDAN_RESULTS: 'SET_NAKDAN_RESULTS',
  GENRE_CLASSIFY_RUNNING: 'GENRE_CLASSIFY_RUNNING',
  GENRE_CLASSIFY_TIMED_OUT: 'GENRE_CLASSIFY_TIMED_OUT',
  GENRE_CLASSIFY_FAILED: 'GENRE_CLASSIFY_FAILED',
  SET_GENRE_CLASSIFY_RESULTS: 'SET_GENRE_CLASSIFY_RESULTS'
}

export const Actions = {
  RUN_NAKDAN: 'RUN_NAKDAN',
  PROCESS_LOGIN: 'PROCESS_LOGIN',
  LOGOUT: 'LOGOUT'
}
